module.exports = __webpack_public_path__ + "static/media/ellipsis-h-alt.928545e5.svg";